import { Typography, Stack, Box } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { Trans } from "react-i18next";
import { Resources, useResource } from "Translations/Resources";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { getApiUrl } from "Infrastructure/Api/Api";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { MooneLiteWarning } from "Components/Affiliate/Customer/MooneLiteWarning";

const RESOURCES = Resources.Components.Affiliate.UserAffiliate;

export const CustomerAffiliateDescription = () => {
  const { isUserInMooneLite } = useIsUserInMooneLite();
  const { t } = useResource();

  const apiUrl = getApiUrl();

  return (
    <Stack gap={4}>
      <Box display="flex" columnGap={2} flexWrap="wrap">
        <Typography
          variant="h6"
          fontSize={["1.188rem", "1.25rem"]}
          display="flex"
          alignItems="center"
          gap={2}
        >
          <FavoriteIcon color="primary" />
          {t(RESOURCES.Title)}
        </Typography>
        <Typography variant="h6" fontSize={["1.188rem", "1.25rem"]}>
          {t(RESOURCES.Subtitle)}
        </Typography>
      </Box>

      <Typography>{t(RESOURCES.Description)}</Typography>
      <Stack>
        <Typography fontWeight={600}>{t(RESOURCES.HowItWorksTitle)}</Typography>
        <Typography>
          <Trans components={{ newline: <br /> }}>
            {t(RESOURCES.HowItWorks)}
          </Trans>
        </Typography>
      </Stack>
      <Typography>{t(RESOURCES.Rewards)}</Typography>
      <Typography>
        {t(RESOURCES.TermsLinkPretext)}{" "}
        <Box component="span" sx={{ lineBreak: "", display: "inline-flex" }}>
          <UnstyledLink
            to={t(RESOURCES.TermsLinkUrl, { apiUrl })}
            target="_blank"
            rel="noreferrer"
          >
            {t(RESOURCES.TermsLink)}
          </UnstyledLink>
          .
        </Box>
      </Typography>
      {isUserInMooneLite && <MooneLiteWarning />}
    </Stack>
  );
};
